'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Box = require('../Box');

var _Box2 = _interopRequireDefault(_Box);

var _AriaClickHandler = require('../AriaClickHandler');

var _AriaClickHandler2 = _interopRequireDefault(_AriaClickHandler);

var _theme = require('../theme/');

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line local-rules/no-deep-relative-imports
// eslint-disable-line local-rules/no-deep-relative-imports
var AlertBox = /*#__PURE__*/(0, _theme.styled)('div', {
  target: 'e1rdmw5w0'
})(_styles2.default.alertBoxContainer, {
  display: 'flex'
}); // eslint-disable-line local-rules/no-deep-relative-imports
// eslint-disable-line local-rules/no-deep-relative-imports


var DefaultCloseButton = /*#__PURE__*/(0, _theme.styled)(_AriaClickHandler2.default, {
  target: 'e1rdmw5w1'
})({
  width: 20,
  height: 20,
  borderRadius: '100%'
});

var IconWrapper = /*#__PURE__*/(0, _theme.styled)('div', {
  target: 'e1rdmw5w2'
})(function (_ref) {
  var theme = _ref.theme;

  return {
    lineHeight: 1,
    marginRight: theme.space.small,
    display: 'inline-block'
  };
});

var Alert = function (_React$PureComponent) {
  (0, _inherits3.default)(Alert, _React$PureComponent);

  function Alert() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Alert);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = Alert.__proto__ || Object.getPrototypeOf(Alert)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      open: _this.props.open
    }, _this.handleClose = function (e) {
      _this.setState({
        open: false
      });
      if (typeof _this.props.onClose === 'function') {
        _this.props.onClose(e);
      }
    }, _this.renderCloseButton = function () {
      var _this$props = _this.props,
          theme = _this$props.theme,
          type = _this$props.type;

      var defaultCloseButton = _react2.default.createElement(
        DefaultCloseButton,
        { onClick: _this.handleClose },
        _react2.default.createElement(
          _Box2.default,
          { center: true },
          _react2.default.createElement(_Icon2.default, { size: 'xsmall', name: 'close', color: theme.components.alert[type].iconColor })
        )
      );
      if (_this.props.closable) {
        if (typeof _this.props.renderCloseButton === 'function') {
          return _this.props.renderCloseButton(_this.handleClose);
        } else {
          return defaultCloseButton;
        }
      }
      return null;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Alert, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.delay) {
        setTimeout(this.handleClose, this.props.delay);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          iconName = _props.iconName,
          type = _props.type,
          theme = _props.theme,
          borderRadius = _props.borderRadius,
          iconClassName = _props.iconClassName,
          otherProps = (0, _objectWithoutProperties3.default)(_props, ['children', 'iconName', 'type', 'theme', 'borderRadius', 'iconClassName']);

      if (!this.state.open) {
        return null;
      }
      return _react2.default.createElement(
        AlertBox,
        (0, _extends3.default)({
          type: type,
          role: 'alert',
          borderRadius: borderRadius
        }, otherProps),
        iconName && _react2.default.createElement(
          IconWrapper,
          { className: iconClassName },
          _react2.default.createElement(_Icon2.default, { size: 'xsmall', name: iconName, color: theme.components.alert[type].iconColor })
        ),
        _react2.default.createElement(
          _Box2.default,
          { verticalAlign: 'middle', flex: 1 },
          children
        ),
        this.renderCloseButton()
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      if (props.open !== state.open) {
        return {
          open: props.open
        };
      }
      return null;
    }
  }]);
  return Alert;
}(_react2.default.PureComponent);

Alert.defaultProps = {
  type: 'info',
  bordered: false,
  open: true
};

exports.default = (0, _theme.withTheme)(Alert);